module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/felden_03-085dcd3362a5ce6c370e6df9397b9c37.jpg";